import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Icon, Button, ButtonGroup } from '@superops/ui-design-system';

import envConfig from '@nile/home/src/Config/env';
import styled from 'styled-components';
import {
  CircleTickOutlineMinor,
  CircleCancelMinor
} from '@shopify/polaris-icons';
import {
  BackgroundIcon,
  getTranslatedText,
  DeleteModal
} from '@nile/components';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const SplitButton = styled.div`
  .approve-icon,
  .reject-icon {
    height: 16px;
    width: 16px;
    margin-right: 8px;
  }
  .Superops-Button {
    min-height: 3.2rem;
    min-width: 4rem;
    height: 25px;
    padding: 0 !important;
  }
  .Polaris-Icon--colorRed svg {
    fill: #de3618 !important;
  }
  .Polaris-Icon--colorGreen svg {
    fill: #50b83c !important;
  }
  .Superops-ButtonGroup--segmented {
    margin-left: 0px;

    .Superops-ButtonGroup__Item:not(:first-child) {
      margin-left: 0px !important;
    }
    .isActivated {
      border: 1px solid black;
    }
  }
`;

function InvoiceAuditActionCell(props) {
  const { cell, intl, handleChange } = props;
  const meta = cell?.row?.original;
  const { actions } = cell.column;
  const [submitActionLoading, setSubmitActionLoading] = useState(false);
  const resetSubmitActionLoading = () => {
    setSubmitActionLoading(false);
  };
  const isEditable = !(
    meta.adjustedBlockHour ||
    meta.adjustedBlockMoney ||
    meta.eligibleBlockHour ||
    meta.eligibleBlockMoney
  );
  if (isEditable) {
    return (
      <SplitButton className="">
        <ButtonGroup segmented>
          <Button
            onClick={() => {
              setSubmitActionLoading(true);
              actions.onClick(
                meta,
                'status',
                'APPROVED',
                resetSubmitActionLoading
              );
            }}
            loading={submitActionLoading}
            icon={<SVGIcon name="SuccessCircle" />}
          />
          <Button
            onClick={() => {
              setSubmitActionLoading(true);
              actions.onClick(
                meta,
                'status',
                'IGNORED',
                resetSubmitActionLoading
              );
            }}
            loading={submitActionLoading}
            icon={
              <SVGIcon name="RejectedCircle" color="red !important" />
            } /* todo design system override */
          />
        </ButtonGroup>
      </SplitButton>
    );
  }
  return '';
}

export default injectIntl(InvoiceAuditActionCell);
